import { useState } from "react";
import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDDatePicker from "components/MDDatePicker";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DataTable2 from "examples/Tables/DataTable2";
import ScenariosLogsData from "./scenariosLogsData";
import ScenariosLogsOverviewTable from "./scenariosLogsOverviewTable";

function ScenariosLogs() {
  const { t } = useTranslation();
  const [scenarioId, setScenarioId] = useState("");
  const [fromTs, setFromTs] = useState(null);
  const [toTs, setToTs] = useState(null);

  const { data, loading, error, fetchData } = ScenariosLogsData();
  const tableData = ScenariosLogsOverviewTable(data);

  const handleSubmit = async (event) => {
    event.preventDefault();
    await fetchData({ scenarioId, fromTs, toTs });
  };

  return (
    <DashboardLayout>
      <MDBox p={3}>
        <MDBox
          component="form"
          onSubmit={handleSubmit}
          display="flex"
          flexWrap="wrap"
          gap={2}
          mb={2}
          alignItems="center"
        >
          <MDInput
            placeholder={t("scenarios.logs.scenarioIdPlaceholder")}
            type="number"
            value={scenarioId}
            onChange={(e) => setScenarioId(e.target.value)}
            sx={{ minWidth: "180px" }}
            required
          />
          <MDDatePicker
            input={{ placeholder: t("scenarios.logs.from"), sx: { minWidth: "240px" } }}
            value={fromTs}
            options={{
              enableTime: true,
              enableSeconds: true,
              dateFormat: "Y-m-d\\TH:i:S",
              time_24hr: true,
            }}
            onChange={(dates) => setFromTs(dates?.[0] || null)}
          />
          <MDDatePicker
            input={{ placeholder: t("scenarios.logs.to"), sx: { minWidth: "240px" } }}
            value={toTs}
            options={{
              enableTime: true,
              enableSeconds: true,
              dateFormat: "Y-m-d\\TH:i:S",
              time_24hr: true,
            }}
            onChange={(dates) => setToTs(dates?.[0] || null)}
          />
          <MDButton type="submit" variant="gradient" color="info">
            {t("scenarios.logs.submit")}
          </MDButton>
        </MDBox>

        {loading && (
          <MDBox mb={2}>
            <MDTypography variant="h6" fontWeight="medium" gutterBottom>
              <CircularProgress />
            </MDTypography>
          </MDBox>
        )}

        {error && (
          <MDBox mb={2}>
            <MDTypography variant="h6" color="error" gutterBottom>
              {error}
            </MDTypography>
          </MDBox>
        )}

        <div className="diagramContainer">
          <div className="scrollable-100">
            <DataTable2 table={tableData} canSearch />
          </div>
        </div>
      </MDBox>
    </DashboardLayout>
  );
}

export default ScenariosLogs;
